import { Routing } from "helpers/routing";
import { createContext } from "react";
const MatchDatasourceIdentifierContext = createContext<{
  params?: Routing.MatchDatasourceIdentifierParams
}>({})

export default MatchDatasourceIdentifierContext
